module.exports = __webpack_public_path__ + "img/mechanical-engineering.314c1fcb.jpg";